export const LIST_URL =
  "https://api.themoviedb.org/3/movie/popular?api_key=ca3b31f06bb62989bbf688f342bd0dcb&language=en-US&page=1";
export const DETAIL_URL = (
  movieId
) => `https://api.themoviedb.org/3/movie/${movieId}?api_key=ca3b31f06bb62989bbf688f342bd0dcb
&language=en-US`;
